import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import constants from 'app/constants'
import AdaptiveImage from 'components/elements/AdaptiveImage/AdaptiveImage'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import { useLineItemContext } from '../LineItem'
import styles from './Author.module.scss'

/**
 * The `Author` component
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Author = forwardRef((props, forwardedRef) => {
  const { Tag, children, className, path, thumbnail, ...rest } = props
  const { isIntersecting } = useLineItemContext()
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, styles.author]),
    [className]
  )

  return (
    <Tag ref={ref} className={classNameOutput} {...rest}>
      <span>{children}</span>
      <div className={styles.icon}>
        {isIntersecting && (
          <AdaptiveImage
            className={styles.brandThumbnail}
            src={thumbnail}
            path={path}
            sizes={[20, 40]}
          />
        )}
      </div>
    </Tag>
  )
})

// Display name
Author.displayName = 'Author'

/** @type {object} */
Author.propTypes = {
  Tag: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  thumbnail: PropTypes.string,
  path: PropTypes.string
}

/** @type {object} */
Author.defaultProps = {
  Tag: 'div',
  children: null,
  className: '',
  thumbnail: '',
  path: constants.PATH_CDN
}

// Memoize
export default memo(Author)
